import React, { Component } from "react";

class Facts extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const product = this.props.product;

        return (
            <div className="facts-tab-container">
                <div className="facts-tab-content">
                    <table className="facts-tab__facts-list">
                        <tbody>
                            {product.ProductFacts.map((fact, index) => (
                                <tr key={index}>
                                    <td className="label">{fact.Label}</td>
                                    <td className="value">
                                        <div
                                            className="content-rich-text"
                                            dangerouslySetInnerHTML={{ __html: fact.Text }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default Facts;
